namespace Matrix.Rebalancer {
    export class PluginColumns {
        static columnsKey = 'Rebalancer.Plugin';
    }
}
